import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {environment} from "environments/environment";
import {Users} from "../modal/users";
import {Address} from "../modal/address";

@Injectable({
    providedIn: "root",
})
export class AppSettingService {

    constructor(public _apiService: ApiService) {
    }

    isDevMode() {
        return environment.server == "DEV"
    }

    compareObject(obj1: any, obj2: any): boolean {
        return JSON.stringify(obj1) == JSON.stringify(obj2);
    }

    getUserPersonalInfo(userProfile: Users): any {
        return {
            firstName: userProfile.firstName,
            lastName: userProfile.lastName,
            email: userProfile.email,
            mobile: userProfile.mobile
        }
    }

    getDemographicInfo(address: Address): any {
        if (address)
            return {
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                city: address.city,
                state: address.state,
                country: address.country,
                zipCode: address.zipCode,
            }
        else
            return {}
    }

    getFileName(path: string): string {
        let splits = path.split("/");
        return splits[splits.length - 1];
    }

    getFilePath(path: string): string {
        path = path.replace(environment.externalDocumentPath, '/download-resource/');
        path = path.replace("/Users/vivekpatel/git/fraud_detection/", '/download-resource/');
        return path.replace(environment.externalDocumentPath, '/download-resource/');
    }

    getDocumentList() : string[]{
        return [
            "DRIVING_LICENSE",
            "RC",
            "INSURANCE",
            "AADHAAR",
            "PAN"
        ]
    }
}
